import { useEffect, useMemo } from "react";
import { useStore } from "../state/store";

const CATEGORIES = ["All", "Cat 5", "Cat 4", "Cat 3", "Cat 2", "Cat 1", "TS", "TD"];

export default function ExplorerSidebar() {
  const ex = useStore((s) => s.explorer);
  const loadIndex = useStore((s) => s.loadExplorerIndex);
  const select = useStore((s) => s.selectExplorerStorm);
  const setF = useStore((s) => s.setExplorerFilters);

  useEffect(() => {
    void loadIndex();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const years = useMemo(() => {
    const ys = Array.from(new Set(ex.index.map((r) => r.year))).sort((a, b) => b - a);
    return ys;
  }, [ex.index]);

  const filtered = useMemo(() => {
    const q = ex.filters.search.trim().toLowerCase();
    return ex.index.filter((r) => {
      if (ex.filters.year !== "all" && r.year !== ex.filters.year) return false;
      if (ex.filters.category !== "All" && r.category !== ex.filters.category) return false;
      if (q && !r.display_name.toLowerCase().includes(q)) return false;
      return true;
    });
  }, [ex.index, ex.filters]);

  return (
    <>
      <label className="muted xs">{ex.index.length} STORMS · 2004–2025</label>

      <input
        className="storm-select" style={{ marginBottom: 6 }}
        placeholder="🔍 Search (e.g. Katrina)"
        value={ex.filters.search}
        onChange={(e) => setF({ search: e.target.value })}
      />
      <div className="row">
        <select className="storm-select" value={ex.filters.year}
          onChange={(e) => setF({ year: e.target.value === "all" ? "all" : Number(e.target.value) })}>
          <option value="all">All years</option>
          {years.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
        <select className="storm-select" value={ex.filters.category}
          onChange={(e) => setF({ category: e.target.value })}>
          {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      </div>

      <div className="explorer-list">
        {filtered.map((r) => (
          <button
            key={r.storm_id}
            className={ex.selectedId === r.storm_id ? "explorer-row selected" : "explorer-row"}
            onClick={() => void select(r.storm_id)}
          >
            <span className="ename">{r.display_name}</span>
            <span className="muted emeta">{r.category} · {r.overall_score}/10</span>
          </button>
        ))}
        {filtered.length === 0 && <div className="muted sm" style={{ padding: 8 }}>No storms match.</div>}
      </div>

      {ex.error && <div className="error">Explorer error: {ex.error}</div>}
    </>
  );
}
